import RadioButton from './RadioButton/RadioButton.vue';
import Vue from 'vue';
import BaseKeyboard from './BaseKeyboard/BaseKeyboard.vue';
import NumKeyboard from '@/components/common/NumKeyboard/NumKeyboard.vue';
import FixedTable from '@/components/common/FixedTable/FixedTable.vue';

Vue.component('RadioButton', RadioButton);
Vue.component('BaseKeyboard', BaseKeyboard);
Vue.component('NumKeyboard', NumKeyboard);
Vue.component('FixedTable', FixedTable);

type FitTextBindingValue = {
  minFontSizePx?: number;
};

function fitText(el: HTMLElement, bindingValue?: FitTextBindingValue) {
  if (!el) return;
  const prevInlineFontSize = el.style.fontSize;
  el.style.fontSize = '';
  const baseFontSizePx = parseFloat(window.getComputedStyle(el).fontSize) || 0;
  el.style.fontSize = prevInlineFontSize;

  if (!baseFontSizePx) return;

  el.style.fontSize = `${baseFontSizePx}px`;

  const clientWidth = el.clientWidth;
  const scrollWidth = el.scrollWidth;
  if (!clientWidth || !scrollWidth) return;

  if (scrollWidth <= clientWidth) return;

  const minFontSizePx =
    bindingValue && typeof bindingValue.minFontSizePx === 'number' ? bindingValue.minFontSizePx : 8;
  const nextFontSizePx = Math.max(minFontSizePx, Math.floor((baseFontSizePx * clientWidth) / scrollWidth));
  el.style.fontSize = `${nextFontSizePx}px`;
}

function scheduleFitText(el: HTMLElement, bindingValue?: FitTextBindingValue) {
  const nextText = (el.textContent || '').trim();
  const nextClientWidth = el.clientWidth;
  const lastText = (el as any).__fitTextLastText as string | undefined;
  const lastClientWidth = (el as any).__fitTextLastClientWidth as number | undefined;
  if (lastText === nextText && lastClientWidth === nextClientWidth) return;
  (el as any).__fitTextLastText = nextText;
  (el as any).__fitTextLastClientWidth = nextClientWidth;
  requestAnimationFrame(() => fitText(el, bindingValue));
}

Vue.directive('fit-text', {
  inserted(el: HTMLElement, binding: any) {
    scheduleFitText(el, binding && binding.value);

    const ResizeObserverCtor = (window as any).ResizeObserver as any;
    if (ResizeObserverCtor) {
      const ro = new ResizeObserverCtor(() => scheduleFitText(el, binding && binding.value));
      ro.observe(el);
      (el as any).__fitTextResizeObserver = ro;
    }
  },
  componentUpdated(el: HTMLElement, binding: any) {
    scheduleFitText(el, binding && binding.value);
  },
  unbind(el: HTMLElement) {
    const ro = (el as any).__fitTextResizeObserver;
    if (ro && typeof ro.disconnect === 'function') ro.disconnect();
    delete (el as any).__fitTextResizeObserver;
    delete (el as any).__fitTextLastText;
    delete (el as any).__fitTextLastClientWidth;
  },
 });



// WEBPACK FOOTER //
// ./src/components/common/reg.ts